import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { availableSubjects, default_subjectIcon_path, subjectIcon_path } from 'projects/selflearnv2-ui/src/app/constants/app.constants';

@Component({
  selector: 'app-subject-topic-header',
  templateUrl: './subject-topic-header.component.html',
  styleUrls: ['./subject-topic-header.component.css']
})
export class SubjectTopicHeaderComponent implements OnInit {

  @Input() bannerData:any;
  @Input() bannerSubject:string;
  @Input() isTopicsHeader:boolean;
  @Input() SelctedBookName:any;

  constructor(public router:Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {

  }

  getSubjectIconName(subjectName: any) {
    const found = availableSubjects.find((element: any) => element.toLowerCase() == subjectName.toLowerCase());
    return (found) ? subjectIcon_path + found
      : default_subjectIcon_path;
  }
  getSubjectIcon(subjectName: any) {
    const found = availableSubjects.find((element: any) => element.toLowerCase() == subjectName.toLowerCase());
    return (found) ? subjectIcon_path + found + '-new-icon.svg'
      : default_subjectIcon_path + '.svg';
  }

  navigateToSelfLearnHome(){
    this.selfLearnService.removlearnTabExpandRowIndex();
    const navigationPath = (this.isTopicsHeader)?'selfLearn-V2/subject':'selfLearn-V2';
    this.router.navigateByUrl(navigationPath);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.body.scrollTop > 200 ||
      document.documentElement.scrollTop > 200) {
      document.getElementById('pageHeaderBanner')?.classList.add('hdr-collaps');
    } else {
      document.getElementById('pageHeaderBanner')?.classList.remove('hdr-collaps');
    }
  }

}
